import React from 'react';
import Padding from './padding';
import ZeroHeight from './zero-height';

const PaddingWrapper = ({
  padding,
  children,
}) => {
  if (['zeroheight', 'pullover'].includes(padding)) {
    return (
      <ZeroHeight $padding={padding}>
        <Padding $padding={padding}>
          {children}
        </Padding>
      </ZeroHeight>
    );
  }
  return (
    <Padding $padding={padding}>
      {children}
    </Padding>
  );
};

export default PaddingWrapper;
